import { FiAlertCircle } from 'react-icons/fi'

import moment from 'moment'

import Tooltip from '~/components/Tooltip'
import i18n from '~/i18n'

import { ROAS_CUTOFF_DATE } from '../../constants'
import { useConversionRateCutoffState } from '../../hooks/useConversionRateCutoffState'

/** Chave i18n do alerta de cutoff da Taxa de conversão, por estado do período. */
const ALERT_KEY: Record<'mixed' | 'before', string> = {
  mixed: 'rm:alerts.conversionRateCutoffMixed',
  before: 'rm:alerts.conversionRateCutoffBefore'
}

interface ConversionRateCutoffAlertIconProps {
  /** Considera também o período de comparação (só existe nos cards). */
  checkCompare?: boolean
}

/**
 * Ícone de alerta específico da "Taxa de conversão": calcula por conta
 * própria se o período toca o cutoff de atribuição de ROAS e, se sim, exibe
 * o texto correspondente ('mixed' ou 'before'). Não renderiza nada quando o
 * período é inteiramente posterior ao cutoff.
 */
export function ConversionRateCutoffAlertIcon({
  checkCompare = false
}: ConversionRateCutoffAlertIconProps = {}): JSX.Element | null {
  const cutoffState = useConversionRateCutoffState({ checkCompare })

  if (cutoffState === 'none') return null

  const translate = i18n.t as unknown as (
    key: string,
    options?: Record<string, string>
  ) => string
  const cutoff = moment(ROAS_CUTOFF_DATE, 'DD/MM/YYYY')
  const dateFormat = translate('c:patterns.date')
  const date = cutoff.format(dateFormat)
  const previousDate = cutoff.clone().subtract(1, 'day').format(dateFormat)
  const text = translate(ALERT_KEY[cutoffState], { date, previousDate })

  return (
    <span
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <Tooltip noMargin text={text}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            color: '#d99a2b',
            height: '100%'
          }}
        >
          <FiAlertCircle size={13} />
        </span>
      </Tooltip>
    </span>
  )
}
